import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { BrandColors } from '../../constants/brandColors';

export const ProgressBarStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    progressBox: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      bottom: '2rem',
      background: theme.palette.background.default,
      padding: '2.75rem 1rem 3.125rem 1rem',
      [theme.breakpoints.down('sm')]: {
        padding: '2rem 1rem 2.5rem 1rem',
      },
    },
    progress: {
      width: '100%',
      minWidth: '85vw',
      [theme.breakpoints.up('md')]: {
        maxWidth: '764px',
        margin: '0 auto',
        minWidth: '375px',
      },
    },
    progressContainer: {
      flexGrow: 1,
      height: '8px',
      overflow: 'hidden',
      position: 'relative',
      width: '100%',
      marginBottom: '11px',
      borderRadius: '8px',
    },
    progressBg: {
      backgroundColor: BrandColors.grey41,
      opacity: 0.35,
      width: '100%',
      height: '100%',
      position: 'absolute',
      borderRadius: '8px',
    },
    progressBar: {
      backgroundColor: theme.palette.primary.main,
      width: '0%',
      height: '100%',
      position: 'absolute',
      borderRadius: '8px',
      transition: 'width 0.2s ease-in-out',
    },
    labelLt: {
      textAlign: 'left',
      fontWeight: 'bold',
      lineHeight: '20px',
      fontSize: '0.75rem',
      color: theme.palette.default?.main,
      position: 'absolute',
      left: 0,
      [theme.breakpoints.up('md')]: {
        fontSize: '0.75rem',
      },
    },
    labelRt: {
      marginLeft: '8px',
      textAlign: 'right',
      fontWeight: 'bold',
      lineHeight: '20px',
      fontSize: '0.75rem',
      cursor: 'pointer',
      color: theme.palette.default?.main,
      position: 'absolute',
      right: 0,
      textTransform: 'uppercase',
      [theme.breakpoints.up('md')]: {
        fontSize: '0.75rem',
      },
    },
    progressCount: {
      width: '100%',
      position: 'relative',
    },
  }),
);
